import keyBy from 'lodash/keyBy';
import Vue from 'vue';

import { saveWrap } from './helpers';
import * as folderApi from '@authoringPlatform/../api/folders';
import * as fileApi from '@authoringPlatform/../api/files';

const getDefaultState = () => ({
  folders: {},
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    createFolder: saveWrap(async ({ commit }, payload) => {
      const newFolder = await folderApi.createFolder(payload);
      commit('ADD_FOLDER', { newFolder: { ...newFolder, fileToFileFolder: {} } });
    }),

    updateFolder: saveWrap(async ({ commit }, payload) => {
      const { fileFolderKey: folderKey } = payload;
      await folderApi.updateFolder({ folderKey, payload });
      commit('UPDATE_FOLDER', { folderKey, folderData: payload });
    }),

    deleteFolder: saveWrap(async ({ commit }, folderKey) => {
      await folderApi.deleteFolder(folderKey);
      commit('DELETE_FOLDER', { folderKey });
    }),

    createFile: saveWrap(async ({ commit }, { folderKey, payload }) => {
      const newFile = await fileApi.createFile(payload);
      commit('ADD_FILE', { folderKey, newFile });
    }),

    updateFile: saveWrap(async ({ commit }, { folderKey, payload }) => {
      await fileApi.updateFile({ fileKey: payload.fileKey, payload });
      commit('UPDATE_FILE', {
        folderKey,
        fileKey: payload.fileKey,
        fileData: payload,
      });
    }),

    deleteFile: saveWrap(async ({ commit }, { folderKey, fileKey }) => {
      await fileApi.deleteFile(fileKey);
      commit('DELETE_FILE', { folderKey, fileKey });
    }),
  },

  mutations: {
    INITIALIZE_DRIVE: (state, { folders }) => {
      const parsedFolders = folders.map((folder) => ({
        ...folder,
        fileToFileFolder: keyBy(folder.fileToFileFolder, 'FK_fileKey'),
      }));
      state.folders = keyBy(parsedFolders, 'fileFolderKey');
    },

    ADD_FOLDER: (state, { newFolder }) => {
      Vue.set(state.folders, newFolder.fileFolderKey, newFolder);
    },

    UPDATE_FOLDER: (state, { folderKey, folderData }) => {
      const targetFolder = state.folders[folderKey];

      Object.entries(folderData).forEach(([folderAttr, val]) => {
        if (folderAttr in targetFolder) Vue.set(targetFolder, folderAttr, val);
      });
    },

    DELETE_FOLDER: (state, { folderKey }) => {
      Vue.delete(state.folders, folderKey);
    },

    ADD_FILE: (state, { folderKey, newFile }) => {
      Vue.set(state.folders[folderKey].fileToFileFolder, newFile.fileKey, {
        FK_fileFolderKey: folderKey,
        FK_fileKey: newFile.fileKey,
        file: newFile,
      });
    },

    UPDATE_FILE: (state, { folderKey, fileKey, fileData }) => {
      const targetFile = state.folders[folderKey].fileToFileFolder[fileKey].file;

      Object.entries(fileData).forEach(([fileAttr, val]) => {
        if (fileAttr in targetFile) Vue.set(targetFile, fileAttr, val);
      });
    },

    DELETE_FILE: (state, { folderKey, fileKey }) => {
      Vue.delete(state.folders[folderKey].fileToFileFolder, fileKey);
    },
  },
};
